import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = () => ({
  isSearchEngine: ''
});
export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};